"use strict";
(self["webpackChunkFirmSupport"] = self["webpackChunkFirmSupport"] || []).push([[4003],{

/***/ 64003:
/***/ ((module) => {

module.exports = JSON.parse('{"anErrorOccured":"An error occurred","failedToFetchClientInformation":"Something went wrong when retrieving the client information to proceed with the onboarding. Check the client\'s details and try again."}');

/***/ })

}]);